import React from 'react';
import classNames from 'classnames';

export const ListingListItemSkeleton = ({ loading }) => {
  return (
    <div
      className={
        classNames(
          "listing-item-skeleton",
          {"listing-item-skeleton--hidden": !loading}
        )
      }
    >
      <div className="listing-item-skeleton__hero" />
      <div className="listing-item-skeleton__content">
        <div className="listing-item-skeleton__info">
          <div className="info__title" />
          <div className="info__text" />
          <div className="info__text" />
          <div className="info__text" />
        </div>
        <div className="listing-item-skeleton__button" />
      </div>
    </div>
  )
}